<template>
    <div class="relative h-[600px] mt-16">
        <div class="absolute inset-0">
            <img src="https://sx-official.oss-cn-shanghai.aliyuncs.com/%E6%9C%AA%E5%91%BD%E5%90%8D%E9%A1%B9%E7%9B%AE-%E5%9B%BE%E5%B1%82%201%20%281%29.jpeg" 
                 class="w-full h-full object-cover object-top" alt="hero background">
        </div>
        <div class="relative max-w-7xl mx-auto px-4 h-full flex items-center">
            <div class="w-1/2">
                <h1 class="text-5xl font-bold text-gray-800 mb-6" style="color:white">让爱像阳光一样无处不在</h1>
                <p class="text-xl text-gray-600 mb-8" style="color: white;">专业的心理健康服务，为您的心灵护航</p>
                <!--<div class="flex space-x-4">
                    <button class="btn btn-primary btn-large !rounded-button whitespace-nowrap">预约咨询</button>
                    <button class="btn btn-default btn-large !rounded-button whitespace-nowrap">了解更多</button>
                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HeroComponent'
}
</script>